import React, { useState, useRef } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import {connect} from 'react-redux'
import styled from 'styled-components'
import Trigger from 'rc-trigger'
import 'rc-trigger/assets/index.css'
import { FaBars } from 'react-icons/fa'
import MenuItem from './MenuItem'
import { menuItemClick } from 'App/actions'
import Scroll from '../Scroll'


const Menu = ({ menu, handleClick }) => {
  const [ visible, setVisible ] = useState(false)
  const containerRef = useRef(null)
  const buttons = menu && menu.get('buttons')
  if (!menu || !buttons || buttons.size === 0) { return null }

  const handleBlur = e => {
    const relatedTarget = e.relatedTarget || document.activeElement // IE11

    if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
      setVisible(false)
    }
  }

  const handlePopupClick = e => {
    setVisible(false)
    handleClick(e)
  }

  return (
    // Need to set containerRef and pass it to Trigger to avoid menu detaching
    // from bot when embedded in academy
    <Container ref={containerRef} onBlur={handleBlur}>
      <Trigger
        popupAlign={{ points: ['bl', 'tl'], offset: [0, 0] }}
        popupPlacement={'top'}
        destroyPopupOnHide={true}
        zIndex={9999}
        popupVisible={visible}
        popup={<Popup buttons={buttons} handleClick={handlePopupClick} />}
        getPopupContainer={() => containerRef.current }
      >
        <MenuButton aria-expanded="false" title="Menu" onClick={() => setVisible(!visible)}>
          <FaBars />
        </MenuButton>
      </Trigger>
    </Container>
  )
}

const Popup = ({ buttons, handleClick }) => (
  <PopoverContainer>
    <Scroll style={{ maxHeight: 300 }}>
      <List tabIndex='0' role="menubar">
        {buttons.map((button, i) => (
          <MenuItem index={i} key={`btn_menu_${i}`} {...button}
            onClick={handleClick.bind(null, button)} />
        ))}
      </List>
    </Scroll>
  </PopoverContainer>
)

Menu.propTypes = {
  menu: ImmutablePropTypes.map,
}


const mapStateToProps = state => ({
  menu: state.widget.menu
})

const mapDispatchToProps = dispatch => ({
  handleClick: button => dispatch(menuItemClick(button)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)

const Container = styled.div`
  display: flex;
  justify-content: center;
`


const MenuButton = styled.button`
  background: none;
  border: 0px solid;
  cursor: pointer;
  font-size: 20px;
  color: var(--clr-bot-main, ${props => props.theme.primaryColor});
  padding: 0 6px 0 3px;
`

const PopoverContainer = styled.div`
  min-width: 250px;
  background-color: var(--clr-white-to-grey-1, #fff);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 3px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, .1);
`

const List = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 5px;
  margin: 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Menu/index.js